import React, { useState, useEffect, useMemo } from 'react';
import api from '../../services/api'; // Import your custom Axios instance
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import "bootstrap/dist/css/bootstrap.min.css";
import { useNavigate } from "react-router-dom";
import DataGrid, {
  Column,
  Paging,
  Pager,
} from 'devextreme-react/data-grid';
import { LoadPanel } from 'devextreme-react/load-panel';
import { useLocation } from 'react-router-dom';

const schema = () =>
  yup.object().shape({
    agencyID: yup.string().required("Required"),
    officeAbroad: yup.string().required("Required"),
  });

const MoveApplicants = () => {
  const location = useLocation();
  const selectedIds = location.state?.selectedIds;
  const [agencies, setAgencies] = useState(null);
  const [agents, setAgents] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [applicants, setApplicants] = useState([]);
  const navigate = useNavigate();  

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(schema()),
  });

  useEffect(() => {
    if (!selectedIds || selectedIds.length === 0) {
      console.error("No selected IDs provided.");
      return;
    }

    setIsLoading(true);

    api.post('/Applicants/selected', selectedIds)
      .then((res) => {
        const transformedData = res.data.map((item) => ({
          ...item,
          ID: item.id,
        }));
        setApplicants(transformedData);
      })
      .catch((err) => {
        console.error('Error fetching applicants:', err);
      })
      .finally(() => setIsLoading(false));
  }, [selectedIds]);

  useEffect(() => {
    api.get("/Companies/relatedCompanies")
      .then((response) => setAgencies(response.data))
      .catch((error) => console.error("Error fetching agencies:", error));
  }, []);

  useEffect(() => {
    api.get("/Companies/relatedAgents")
      .then((response) => setAgents(response.data))
      .catch((error) => console.error("Error fetching agents:", error));
  }, []);

  const handleFormSubmit = async (data) => {
    const { agencyID, officeAbroad } = data;

    if (!selectedIds || selectedIds.length === 0) {
      alert("Please select at least one applicant.");
      return;
    }

    if (!agencyID || !officeAbroad) {
      alert("Please fill in all required fields.");
      return;
    }

    setIsLoading(true);

    try {
      await api.post(
        `/Applicants/moveApplicants?companyId=${encodeURIComponent(agencyID)}&officeAbroad=${encodeURIComponent(officeAbroad)}`,
        selectedIds
      );
      navigate("/applicants/applicantlist");
    } catch (error) {
      console.error("Error Response:", error.response?.data);
      alert(JSON.stringify(error.response?.data, null, 2));
    } finally {
      setIsLoading(false);
    }
  };

  // Use useMemo to optimize column definitions
  const columns = useMemo(
    () => [
      { field: 'passportNo', caption: 'Passport No' },
      { field: 'fullName', caption: 'Full Name' },
    ],
    []
  );

  return (

    <div className="container mt-4" style={{ maxWidth: "1100px" , maxHeight: "600px", marginBottom: "20px"}}>
      <h5 className="es-label-title">CHANGE STATUS</h5>
      <div className="card p-3">
      <form onSubmit={handleSubmit((data) => handleFormSubmit(data))} className="space-y-4">

        <div className="w-100 h-100 bg-white rounded p-1">
      {/* LoadPanel for loading indicator */}
      <LoadPanel
        shadingColor="rgba(0,0,0,0.4)"
        position={{ of: '.dx-datagrid' }}
        visible={isLoading}
        showIndicator={true}
        shading={false}
        showPane={true}
      />      
    </div>
    
<div className="row mb-1">
        <div className="col-md-6">
            <div className="row">
                <label className="col-sm-4 col-form-label es-field-label">Company</label>
                <div className="col-sm-8 d-flex align-items-center">
                <select {...register("agencyID")} className="form-control">
                    <option value="">Select...</option>
                    {agencies && agencies.map(agencies => (
                    <option key={agencies.companyID} value={agencies.companyID}>
                        {agencies.companyName}
                    </option>
                    ))}
                </select>
                {errors.agencyID && (<i className="bi bi-exclamation-circle text-danger ms-2"></i>)}
                </div>
                                
                <label className="col-sm-4 col-form-label es-field-label"> Agent </label>
                
                <div className="col-sm-8 d-flex align-items-center">
                    <select {...register("officeAbroad")} className="form-control">
                        <option value="">Select...</option>
                        {agents && agents.map(company => (
                        <option key={company.companyID} value={company.companyID}>
                            {company.companyName}
                        </option>
                        ))}
                    </select>
                    {errors.officeAbroad && (<i className="bi bi-exclamation-circle text-danger ms-1"></i>)}
                </div>
              
              <div className="d-flex justify-content-center">
                <hr></hr>
                   <button type="submit" className="btn es-button"> SAVE </button>
              </div>
            </div>
        </div>
        <div className="col-md-6">
          <div className="row">
                <DataGrid
                    dataSource={applicants}
                    showBorders
                    rowAlternationEnabled
                    allowColumnResizing
                    columnAutoWidth
                    focusedRowEnabled
                    keyExpr="ID"
                    height="300px"
                    width="500px"
                >
                    <Paging defaultPageSize={15} />
                    <Pager showPageSizeSelector allowedPageSizes={[10, 20, 50]} showInfo />

                    {columns.map(({ field, caption }) => (
                    <Column key={field} dataField={field} caption={caption} allowFiltering />
                    ))}
                </DataGrid>
          </div>
        </div>
      </div>          
        </form>
        </div>
        </div>
  );
};

export default MoveApplicants;